import {
  DashedRoad,
  GroundShadow,
  HorizontalFadeMask,
  LoaderSvg,
  type VehicleLoaderProps,
  useSvgId,
} from "../loader-svg-parts";
import { VEHICLE_HEADLIGHT, VehicleOutline } from "../vehicle-outline";

export function VehicleLoaderHeadlights({ className }: VehicleLoaderProps) {
  const beamGradientId = useSvgId("vehicle-loader-beam-gradient");
  const maskId = useSvgId("vehicle-loader-headlights-mask");

  return (
    <LoaderSvg viewBox="-6 18 100 40" modifiers="vehicle-loader-driving text-primary" className={className}>
      <defs>
        <linearGradient
          id={beamGradientId}
          gradientUnits="userSpaceOnUse"
          x1={VEHICLE_HEADLIGHT.x}
          x2={94}
          y1="0"
          y2="0"
        >
          <stop offset="0" stopColor="currentColor" stopOpacity="0.45" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
      <HorizontalFadeMask id={maskId} x={-6} y={18} width={100} height={40} />
      <GroundShadow />
      <g mask={`url(#${maskId})`}>
        <DashedRoad x1={-6} x2={94} />
      </g>
      <path
        d={`M${VEHICLE_HEADLIGHT.x} ${VEHICLE_HEADLIGHT.y - 0.8}L94 32V52L${VEHICLE_HEADLIGHT.x} ${VEHICLE_HEADLIGHT.y + 0.8}Z`}
        fill={`url(#${beamGradientId})`}
        className="vehicle-loader-beam"
      />
      <VehicleOutline />
      <circle
        cx={VEHICLE_HEADLIGHT.x - 0.5}
        cy={VEHICLE_HEADLIGHT.y}
        r={2.4}
        className="vehicle-loader-glow fill-primary/30"
      />
    </LoaderSvg>
  );
}
